import type { Meta, StoryFn } from '@storybook/react';
import type { RadioButtonProps } from './RadioButton';

import { RadioButton } from './RadioButton';
import './RadioButton.stories.css';

const codeString = `
  <RadioButton checked={checked} id={id} label={label} name={name} 
    onChange={onChangeFunction} value={value} description={description} /> `;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/RadioButton',
  component: RadioButton,
  argTypes: {
    id: {
      control: 'text',
    },
    label: {
      control: 'text',
    },
    description: {
      control: 'text',
    },
    disabled: {
      control: 'boolean',
    },
    gap: {
      control: 'radio',
    },
  },
  parameters: {
    inspectComponent: RadioButton,
    codeString: codeString,
  },
} as Meta<RadioButtonProps>;

const Template: StoryFn<RadioButtonProps> = (args) => (
  <fieldset className="fieldset">
    <RadioButton {...args} />
  </fieldset>
);

export const RadioButtonExample = Template.bind({});
RadioButtonExample.args = {
  gap: 'normal',
  disabled: false,
  label: 'Sample label',
  description: 'Sample description',
  id: 'de501f21',
};
